import { Html, html, View } from 'rune-ts';
import klass from './CustomerSupportView.module.scss';
import { MPS_CUSTOMER_CENTER_NUMBER } from '@services/MarppleShop/shared/constant';
import { DropdownView } from '@services/MarppleShop/renderApp/components/cells/Footer/views/DropdownView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { FooterData } from '@services/MarppleShop/renderApp/components/cells/Footer/Footer.ts';
import { makeSubScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr';

interface Props {
  is_mobile: boolean;
}

export class CustomerSupportView extends View<Pick<FooterData, 'out_links'> & Props> {
  private texts = {
    customer_support: ET('mps2::footer::customer_support'),
    faq: ET('mps2::footer::faq'),
    inquiry: ET('mps2::footer::inquiry'),
    customer_center_number: T('mshop::Footer::CustomerCenter') + ' ' + MPS_CUSTOMER_CENTER_NUMBER[ET.lang],
    customer_center_info: ET('mps2::footer::customer_center_info'),
    product_delivery_cs: T('mshop::Footer::product_delivery_cs'),
    product_delivery_email: 'cs@marppleshop.com',
    shop_operation_cs: T('mshop::Footer::shop_operation_cs'),
    shop_operation_email: 'partner@marppleshop.com',
    business_alliance_cs: T('mshop::Footer::business_alliance_cs'),
    business_alliance_email: 'creators@marppleshop.com',
    report_center: ET('mps2::footer::신고센터'),
  };

  override template() {
    return html`<div class="${klass.CustomerSupportView}">
      ${new DropdownView({
        title: this.texts.customer_support,
        title_class: font('14_bold_px'),
        contentView: this.getDropdownContent(),
        defaultOpen: !this.data.is_mobile,
        showArrow: this.data.is_mobile,
      })}
    </div> `;
  }

  getDropdownContent(): Html {
    return html`
      <div class="${klass.content_wrap}">
        <div class="${klass.btn_wrap}">
          <!-- 자주 묻는 질문 -->
          <a
            href="${this.data.out_links.customer_center}"
            class="${klass.btn}  ${font('14_bold_px')}"
            data-post-message="${dataStr(makeSubScreenNavigate(this.data.out_links.customer_center))}"
            target="_blank"
          >
            ${this.texts.faq}
          </a>

          <!-- 1:1 문의하기 -->
          <button id="channel_talk_btn" class="${klass.btn} ${font('14_bold_px')}">
            ${this.texts.inquiry}
          </button>

          <!-- 신고센터 -->
          <a
            href="${this.data.out_links.report_center}"
            class="${klass.btn}  ${font('14_bold_px')}"
            data-post-message="${dataStr(makeSubScreenNavigate(this.data.out_links.report_center))}"
            target="_blank"
          >
            ${this.texts.report_center}
          </a>
        </div>
        <ul class="${klass.customer_center_info} ${font('12_medium')}">
          <li>${this.texts.customer_center_number}</li>
          <li>${ET('mps2::footer::customer_center_info')}</li>
          <li>
            ${this.texts.product_delivery_cs}
            <a href="mailto:${this.texts.product_delivery_email}">${this.texts.product_delivery_email}</a>
          </li>
          <li>
            ${this.texts.shop_operation_cs}
            <a href="mailto:${this.texts.shop_operation_email}">${this.texts.shop_operation_email}</a>
          </li>
          <li>
            ${this.texts.business_alliance_cs}
            <a href="mailto:${this.texts.business_alliance_email}">${this.texts.business_alliance_email}</a>
          </li>
        </ul>
      </div>
    `;
  }

  protected override onRender(): void {
    super.onRender();

    const channelTalkButtonEl = this.element().querySelector('#channel_talk_btn');
    if (channelTalkButtonEl) {
      channelTalkButtonEl.addEventListener('click', () => {
        (window as any).ChannelIO('showMessenger');
      });
    }
  }
}
